module.exports = __webpack_public_path__ + "img/流体力学3_2_3.5ac842de.jpg";